import React, { FC } from "react";
import Head from "next/head";

const Favicons: FC = () => {
  return (
    <Head>
      <link rel="apple-touch-icon" href="/img/favicons/touch-icon-iphone.png" />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="/img/favicons/touch-icon-ipad.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="167x167"
        href="/img/favicons/touch-icon-ipad-retina.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/img/favicons/apple-touch-icon.png"
      />

      <link
        href="/img/favicons/apple_splash_2048.png"
        sizes="2048x2732"
        rel="apple-touch-startup-image"
      />
      <link
        href="/img/favicons/apple_splash_1668.png"
        sizes="1668x2224"
        rel="apple-touch-startup-image"
      />
      <link
        href="/img/favicons/apple_splash_1536.png"
        sizes="1536x2048"
        rel="apple-touch-startup-image"
      />
      <link
        href="/img/favicons/apple_splash_1242.png"
        sizes="1242x2208"
        rel="apple-touch-startup-image"
      />
      <link
        href="/img/favicons/apple_splash_1125.png"
        sizes="1125x2436"
        rel="apple-touch-startup-image"
      />
      <link
        href="/img/favicons/apple_splash_750.png"
        sizes="750x1334"
        rel="apple-touch-startup-image"
      />
      <link
        href="/img/favicons/apple_splash_640.png"
        sizes="640x1136"
        rel="apple-touch-startup-image"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/img/favicons/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/img/favicons/favicon-16x16.png"
      />
      <link rel="manifest" href="/img/favicons/site.webmanifest" />
      <link
        rel="mask-icon"
        href="/img/favicons/safari-pinned-tab.svg"
        color="#ff5b01"
      />
      <link rel="shortcut icon" href="/img/favicons/favicon.ico" />
    </Head>
  );
};

export default Favicons;
